import { render, staticRenderFns } from "./ArquivoFolha.vue?vue&type=template&id=4a82844c&"
import script from "./ArquivoFolha.vue?vue&type=script&lang=js&"
export * from "./ArquivoFolha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports